export default {
    /*
    config local
     */
    // API_URL: 'http://sivercoh2-dev.gissol.fr:8080/'


    /*
    config pour mise en production
     */
    API_URL: '/api/'
}
